import styled from 'styled-components';
import {flexGrowItem, flexFixedSizeItem} from '../../../../themes/architecture/css-helpers/flex';

export const ButtonWrapperDefaultBox = styled.div<{buttonsOnSeparateLines?: boolean; flexBasis?: string;}>`
    ${flexGrowItem}
    width: ${({buttonsOnSeparateLines}) => buttonsOnSeparateLines ? "100%" : "40%" };
`;

export const ButtonSpacerDefaultBox = styled.div`
    ${flexFixedSizeItem}
    width: 1rem;
    height: 1.5rem;
`;
